import * as React from 'react'

import { Info } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'

interface IColumnHeaderInfoProps {
  label: string
  info: string
}

export default function ColumnHeaderInfo({
  label,
  info,
}: IColumnHeaderInfoProps): React.ReactElement {
  return (
    <span className="tw:flex tw:items-center tw:gap-1">
      {label}
      <Tooltip>
        <TooltipTrigger render={<Info size={14} />} />
        <TooltipContent className="tw:whitespace-pre-line">
          {info}
        </TooltipContent>
      </Tooltip>
    </span>
  )
}
